<app-side-menu>
  <div class="preventive-history-container">
    <div class="row mb-3">
      <div class="col-12">
        <div class="page-header">
          <h1 class="page-title">
            <i class="fas fa-history me-2"></i>
            Histórico de Preventivas
          </h1>
          <p class="page-subtitle">
            Visualize todas as manutenções preventivas já realizadas nos veículos.
          </p>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select id="statusFilter" class="form-select" [(ngModel)]="selectedStatus" (change)="onFilterChange()">
            <option value="">Todos os status</option>
            <option *ngFor="let s of availableStatuses" [value]="s">{{s}}</option>
          </select>
        </div>
        <div class="filter-group">
          <label for="startDate" class="form-label">Data Inicial:</label>
          <input id="startDate" type="date" class="form-control" [(ngModel)]="startDate" (change)="onFilterChange()">
        </div>
        <div class="filter-group">
          <label for="endDate" class="form-label">Data Final:</label>
          <input id="endDate" type="date" class="form-control" [(ngModel)]="endDate" (change)="onFilterChange()">
        </div>
        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button type="button" class="btn btn-outline-light btn-sm" (click)="retry()">
          <i class="fas fa-redo me-1"></i>
          Tentar novamente
        </button>
      </div>
    </div>

    <div *ngIf="!error">
      <app-table
        [title]="historyTableTitle"
        [data]="items"
        [columns]="columns"
        [loading]="isLoading"
        [actions]="actions"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [itemsPerPage]="pageSize"
        [totalItemsFromBackend]="backendPaginationTotal"
        [hasNextPageFromBackend]="hasNextPage"
        [hasPreviousPageFromBackend]="hasPreviousPage"
        [currentPageFromBackend]="currentPage"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (searchChange)="onSearchChange($event)"
        (pageChange)="onTablePageChange($event)"
        (pageSizeChange)="onTablePageSizeChange($event)">
      </app-table>

      <div
        *ngIf="!isLoading && items.length === 0"
        class="empty-state-simple mt-3">
        <div class="empty-message">
          <i class="fas fa-tools"></i>
          <p>Nenhuma preventiva executada encontrada.</p>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>

